export const FETCH_CHALLENGE = {
  START: 'START_FETCH_CHALLENGE',
  COMPLETE: 'COMPLETE_FETCH_CHALLENGE',
  FAIL: 'FAIL_FETCH_CHALLENGE',
  CLEANUP: 'CLEANUP_FETCH_CHALLENGE',
}

export const UPDATE_CHALLENGE_SIMPLE_DETAILS = {
  START: 'START_UPDATE_CHALLENGE_SIMPLE_DETAILS',
  COMPLETE: 'COMPLETE_UPDATE_CHALLENGE_SIMPLE_DETAILS',
  FAIL: 'FAIL_UPDATE_CHALLENGE_SIMPLE_DETAILS',
}

export const UPDATE_CHALLENGE_IMAGE_DETAILS = {
  START: 'START_UPDATE_CHALLENGE_IMAGE_DETAILS',
  COMPLETE: 'COMPLETE_UPDATE_CHALLENGE_IMAGE_DETAILS',
  FAIL: 'FAIL_UPDATE_CHALLENGE_IMAGE_DETAILS',
}

export const UPDATE_CHALLENGE_RELATIONS_DETAILS = {
  START: 'START_UPDATE_CHALLENGE_RELATIONS_DETAILS',
  COMPLETE: 'COMPLETE_UPDATE_CHALLENGE_RELATIONS_DETAILS',
  FAIL: 'FAIL_UPDATE_CHALLENGE_RELATIONS_DETAILS',
}

export const SET_CHALLENGE_PAGE_TO_DIRTY = 'SET_CHALLENGE_PAGE_TO_DIRTY'
